import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";
import React from "react";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

const LINE_COLORS = ["#5356FB", "#F573B8"];

// Same "line chart once there's enough history" capability as myfit-app's
// HealthRecordDetailScreen — `records` is expected already trimmed to the
// most recent N and ordered oldest-first (see Tracking/index.jsx), so this
// just plots whatever it's handed, one line per field (blood pressure has
// two — systolic/diastolic — everything else just one).
export default function HealthTrendChart({ records, type }) {
  const fields = type ? type.fields : [{ id: "value", label: "Value" }];
  const labels = records.map((r) =>
    new Date(r.recorded_at).toLocaleDateString(undefined, { month: "short", day: "numeric" })
  );
  const data = {
    labels,
    datasets: fields.map((field, i) => ({
      label: field.label,
      data: records.map((r) => r.values[field.id]),
      borderColor: LINE_COLORS[i % LINE_COLORS.length],
      backgroundColor: LINE_COLORS[i % LINE_COLORS.length],
      tension: 0.35,
      pointRadius: 2,
    })),
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { grid: { display: false } },
      y: { grid: { display: false } },
    },
    plugins: {
      legend: { display: fields.length > 1 },
    },
  };
  return (
    <div style={{ height: 180 }}>
      <Line data={data} options={options} />
    </div>
  );
}
